import _ from 'lodash'
import HelperValidate from "utils/helper-validate";

const VariableBuilder = {
	
	form: ( options = {} ) => {
		let values = options;
		
		if( "values" in options ) {
			// Create the values
			values = options[ 'values' ];
			delete options[ "values" ];
			
			// Do the rest
			Object.keys( options ).forEach( function ( index ) {
				const option = options[ index ];
				
				const translationLanguages = _.get( option, 'languages', [] );
				const translationFields = _.get( option, 'fields', [] );
				
				// Create the translations
				const { keys, types, contents, language_codes } = self.translations( translationLanguages, translationFields, values );
				
				// Add the translation results
				values[ index +'_types' ] = types;
				values[ index +'_contents' ] = contents;
				values[ index +'_language_codes' ] = language_codes;
				
				// Remove the posted language values
				Object.keys( keys ).forEach( function ( key_index ) {
					const key = keys[ key_index ];
					delete values[ key ];
				});
			});
		}
		
		// Call the build which removes empty items
		values = VariableBuilder.build( values );
		
		return values;
	},
	
	toArray: ( prefix, values ) => {
		let newValues = [];
		
		Object.keys( values ).forEach( function ( key ) {
			const value = values[ key ];
			
			if( key.startsWith( prefix ) && HelperValidate.isValid( value ) ) {
				delete values[ key ];
				
				newValues.push( value );
			}
		});
		
		values[ prefix ] = newValues;
		return values;
	},
	
	build: ( variables = {} ) => {
		let newVariables = {};
		Object.keys( variables ).forEach( function ( key ) {
			let value = _.get( variables, [ key ], null );
			
			if( _.includes( ['guid'], key ) || _.includes( key?.toLowerCase() ?? '', '_guid') ) {
				newVariables[ key ] = (value === null || value === 'create' ) ? '' : value;
				return;
			}
			
			const valueType = typeof value;
			
			let canAdd = false;
			switch( valueType ) {
				case 'object':
				case 'array':
					if( value !== null && value.length > 0 ) {
						canAdd = true
					}
					break;
					
				default:
					if( value !== null && value !== '' ) {
						canAdd = true
					}
			}
			
			// Add it
			if( canAdd ) {
				if( (key?.toLowerCase() ?? '') === 'search' || _.includes( key?.toLowerCase() ?? '', 'search') ) {
					value = "%"+value+"%";
				}
				
				newVariables[ key ] = value;
			}
		} );
		
		return newVariables
	},
	
	translations: ( languages, fields, values ) => {
		let keys = [];
		let types = [];
		let contents = [];
		let language_codes = [];
		
		_.forEach( languages, language => {
			return (
				_.forEach( fields, field => {
					const languageCode = typeof language === "string" ? language : language.code;

					const key = field + '__' + languageCode;
					const value = _.get( values, [ key ], '' );

					keys.push( key );
					types.push( field );
					contents.push( value );
					language_codes.push( languageCode );

					return true;
				})
			);
		});
		
		return {
			keys: keys,
			types: types,
			contents: contents,
			language_codes: language_codes,
		}
	},
}

export default VariableBuilder
